
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import {
  diyEvaluate,
  getTaskDiyEvaluateList,
  ModifyDiyEvaluate,
} from "@/api/orderTask";

@Component({
  name: "OrderEvaluateNew",
  components: {},
})
export default class extends Vue {
  private evaluateData: any = {};
  private textarea = "";

  private orderEvaList: any = [];
  private isModify: any = false;

  created() {
    this.evaluateData = JSON.parse(this.$route.query.evaluateData as string);
    this.isModify = this.$route.query.isModify
      ? parseInt(this.$route.query.isModify as string) === 1
      : false;
    this.getTaskDiyEvaluateList();
  }
  private getTaskDiyEvaluateList() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      order_id: this.evaluateData.order.id,
      order_service_id: this.evaluateData.order_service.id,
      service_company_id: this.evaluateData.order_service.servicer_company_id,
      source_type: 1,
    };
    getTaskDiyEvaluateList(params).then((res: any) => {
      if (res.data) {
        this.orderEvaList = res.data.repair_diy_evaluate_list;
        if (!this.isModify) {
          for (let i = 0; i < this.orderEvaList.length; i++) {
            this.orderEvaList[i].evaluate_dimension.map(
              (evaluateDimension: any) => {
                evaluateDimension.score_num=10
              }
            );
            this.orderEvaList[i].diy_evaluate_score_num = parseFloat('100').toFixed(1)
            this.orderEvaList[i].repair_diy_evaluate_score_num = this.orderEvaList[i].diy_evaluate_score_num;
          }
        }
        this.$forceUpdate()
      }
    });
  }

  private numberHandle(d: any, val: any, order: any) {
    // if (d.score_num === val) {
    //   d.score_num = "";
    //   return;
    // } else {
      d.score_num = val;
    // }
    for (let i = 0; i < this.orderEvaList.length; i++) {
      if (this.orderEvaList[i].id === order.id) {
        this.orderEvaList[i].diy_evaluate_score_num = 0;
        this.orderEvaList[i].evaluate_dimension.map(
          (evaluateDimension: any) => {
            if (evaluateDimension.score_num) {
              this.orderEvaList[i].diy_evaluate_score_num +=
                (evaluateDimension.score_num * evaluateDimension.weight) / 10;
            }
          }
        );
        this.orderEvaList[i].diy_evaluate_score_num = parseFloat(
          this.orderEvaList[i].diy_evaluate_score_num
        ).toFixed(1);
        this.orderEvaList[i].repair_diy_evaluate_score_num =
          this.orderEvaList[i].diy_evaluate_score_num;
      }
    }
    this.$forceUpdate();
  }

  private detailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: "/order/orderToDetail",
      query: {
        order_service_id: val.order_service.id,
        orderId: val.order.id,
        showComplaintBtn: "1",
      },
    });
    window.open(routeData.href);
  }
  private getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    }

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = "";
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = "已催单" + r.order.reminder.count + "次";
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      },
      {
        type: "warning",
        label: urgent,
        plain: plain,
      },
    ];
  }
  private modifyEvaluateHandle(val: any) {
    let err: any = [];
    if (val.evaluate_dimension) {
      val.diy_evaluate_score_num = 0;
      val.evaluate_dimension.map((evaluateDimension: any) => {
        if (
          !(
            evaluateDimension.score_num ||
            parseInt(evaluateDimension.score_num) === 0
          )
        ) {
          err.push({
            oreder: val,
            evaluateDimension: evaluateDimension,
          });
        } else {
          val.diy_evaluate_score_num +=
            (evaluateDimension.score_num * evaluateDimension.weight) / 10;
        }
      });
    }
    val.diy_evaluate_score_num = parseFloat(val.diy_evaluate_score_num).toFixed(
      1
    );
    if (err && err.length > 0) {
      this.showErrorMsg(
        "请选择" + err[0].evaluateDimension.dimension_name + "的评分"
      );
      return;
    }
    console.log(val);
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      order_id: this.evaluateData.order.id,
      order_service_id: this.evaluateData.order_service.id,
      service_company_id: this.evaluateData.order_service.servicer_company_id,
      order_task_id: val.id,
      diy_evaluate_score_num: val.diy_evaluate_score_num,
      diy_evaluate_remark: val.repair_diy_evaluate_remark
        ? val.repair_diy_evaluate_remark
        : "",
    };
    params.evaluate_dimension_json = JSON.stringify(val.evaluate_dimension);
    ModifyDiyEvaluate(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.$router.go(-1);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private submitHandle() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      order_id: this.evaluateData.order.id,
      order_service_id: this.evaluateData.order_service.id,
      service_company_id: this.evaluateData.order_service.servicer_company_id,
      source_type: 1,
    };
    let err: any = [];
    this.orderEvaList.map(async(ov: any) => {
      if (ov.evaluate_dimension) {
        ov.diy_evaluate_score_num = 0;
        await ov.evaluate_dimension.map((evaluateDimension: any) => {
          if (
            !(
              evaluateDimension.score_num ||
              parseInt(evaluateDimension.score_num) === 0
            )
          ) {
            err.push({
              oreder: ov,
              evaluateDimension: evaluateDimension,
            });
          } else {
            ov.diy_evaluate_score_num +=
              (evaluateDimension.score_num * evaluateDimension.weight) / 10;
          }
        });
        ov.diy_evaluate_score_num = parseFloat(
          ov.diy_evaluate_score_num
        ).toFixed(1);
      }
    });
    if (err && err.length > 0) {
      this.showErrorMsg(
        "请选择" + err[0].evaluateDimension.dimension_name + "的评分"
      );
      return;
    }
    let arr: any = [];
    this.orderEvaList.map((ov: any) => {
      arr.push({
        order_task_id: ov.id,
        diy_evaluate_score_num: ov.diy_evaluate_score_num,
        diy_evaluate_remark: ov.repair_diy_evaluate_remark
          ? ov.repair_diy_evaluate_remark
          : "",
        evaluate_dimension: ov.evaluate_dimension,
      });
    });
    params.evaluate_json = JSON.stringify(arr);
    diyEvaluate(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.$router.go(-1);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
